import './FieldArrayValueInlineControl.css';

import { cn } from '##/utils/bem';

export const cnFieldArrayValueInlineControl = cn(
  'FieldArrayValueInlineControl',
);
